import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
    IDispatcherAssignRequest, IDispatcherAssignResponse
} from '../../models/dispatcher/dispatcherAssign.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../models/https';
import useHttps from '../useHttps';

const useAssignDispatcher = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const onAssignDispatcherError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating dispatcher'
    );
  };

  const onAssignDispatcherSuccess = ({
    message,
  }: SuccessHttpResponse<IDispatcherAssignResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const assignDispatcher = (data: IDispatcherAssignRequest) => {
    const url: HttpConfig = {
      url: `general-service/v1/picklist/${data.picklistId}/dispatcher/${data.dispatcherId}`,
      method: 'put',
      data,
    };

    request(
      url,
      onAssignDispatcherSuccess,
      setLoading,
      onAssignDispatcherError
    );
  };

  return { assignDispatcher, loading, resetInputFields };
};

export default useAssignDispatcher;
